module.exports = __webpack_public_path__ + "media/images/top/more-icon-a023c8a191a9043c6626a463b97b456f.svg";